// Formati Brother QL-700 supportati
export const LABEL_FORMATS = [
  { key: "29x62", label: "29×62 mm (DK-11209)", w: 248, h: 116, widthMm: 62, heightMm: 29, qrMm: 25, small: true },
  { key: "29x90", label: "29×90 mm (DK-11201)", w: 360, h: 116, widthMm: 90, heightMm: 29, qrMm: 25, small: true },
  { key: "50x100", label: "50×100 mm (5×10 cm)", w: 400, h: 200, widthMm: 100, heightMm: 50, qrMm: 32, small: false },
  { key: "62x100", label: "62×100 mm (DK-11202)", w: 400, h: 248, widthMm: 100, heightMm: 62, qrMm: 36, small: false },
];

